﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorFeeReceiverContract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const ValidatorFeeReceiverABI_1 = require("./abi/ValidatorFeeReceiverABI");
class ValidatorFeeReceiverContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, ValidatorFeeReceiverABI_1.ValidatorFeeReceiverABI.GetABI());
    }
    getToValidatorsPLS() {
        return __awaiter(this, void 0, void 0, function* () { const value = yield this._call("toValidatorsPLS"); return this._toEther(value); });
    }
    getValidatorsCount() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this._call("validatorsCount");
            if (!result)
                return 0;
            return parseInt(result);
        });
    }
    getLastUpdateTimestamp() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("lastUpdateTimestamp"); });
    }
    getRewardAddress() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("rewardAddress"); });
    }
    getStatsCollectorAddress() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("statsCollectorAddress"); });
    }
    getBnbAddress() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("bnbAddress"); });
    }
    update(withBNB) {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("update", withBNB); });
    }
    needUpdate() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._callInSilence("needUpdate"); });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalance");
            return this._toEther(res);
        });
    }
}
exports.ValidatorFeeReceiverContract = ValidatorFeeReceiverContract;
//# sourceMappingURL=ValidatorFeeReceiverContract.js.map